import {AfterViewInit, Directive, ElementRef, Inject, PLATFORM_ID} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Directive({
  selector: '[ui-autofocus]'
})
export class UiAutofocusDirective implements AfterViewInit {

  constructor(private el: ElementRef, @Inject(PLATFORM_ID) private platformId: any) {
    
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.el.nativeElement.focus();
    }
  }
}
